import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Label } from '../Label';
import { colorPalette } from '../../../colorPalette';
import { Boost } from '@next-common/shared-svg';
export const ClubRTagCashbackLabel = ({ value, baseValue, type, hasMulti = false, hasBoost, hasDescription = true, }) => {
    const styles = ClubRTagCashbackLabelStyles();
    return (React.createElement(Stack, { direction: "row", alignItems: "baseline", spacing: "4px", flexWrap: 'wrap', sx: styles.overflow },
        React.createElement(Stack, { direction: "row", alignItems: "center", sx: styles.overflow },
            hasBoost && (React.createElement(Stack, { "data-qa": "icon", sx: { marginRight: '4px' } },
                React.createElement(Boost, null))),
            React.createElement(Label, { "data-qa": "label", backgroundColor: "red100", textColor: "red800", textTransform: "lowercase", letterSpacing: "0", padding: "small" },
                hasMulti && "jusqu'à ",
                value,
                type === 'e' ? ' €' : '%')),
        hasDescription && (React.createElement(Typography, { "data-qa": "text", sx: [
                styles.overflow,
                {
                    color: colorPalette.gray900,
                    fontSize: '12px',
                    lineHeight: '14px',
                },
            ] }, hasBoost && baseValue ? ` au lieu de ${baseValue}${type === 'e' ? ' €' : '%'}` : 'de cashback'))));
};
const ClubRTagCashbackLabelStyles = () => ({
    overflow: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
});
